import './edit-tag.scss';
import manageStudentsTemplate from './manage-students/manage-students.html';
import template from './edit-tag.html';

class EditTagComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    TagService,
    StudentService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.TagService = TagService;
    this.StudentService = StudentService;
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.tag) {
      this.tag = {...this.tag};
    }

    if (changes.groups) {
      this.groups = Object.assign([], this.groups);
    }

    if (changes.schoolClasses) {
      this.schoolClasses = Object.assign([], this.schoolClasses);
    }
  }

  manageStudents(ev) {
    this.StudentService.getAll().then(students => {
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'ManageStudentsController',
        template: manageStudentsTemplate,
        clickOutsideToClose: true,
        locals: {
          students,
          tag: this.tag,
          groups: this.groups,
          schoolClasses: this.schoolClasses
        },
        targetEvent: ev
      })
        .then(result => {
          this.tag.data.students.splice(0, this.tag.data.students.length);
          Object.assign(this.tag.data.students, result);
        }, () => {})
        .finally(() => {
        });
    });
  }

  save(form) {
    if (form.$invalid) {
      return false;
    }

    this.tag.data.students = this.tag.data.students.map(student => student.id);
    this.TagService.update(this.tag.data)
      .then(() => {
        this.$state.go('modules.informations.tags');
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Edytowano etykietę')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.newError({
            locals: {error}
          })
        );
      });
  }
}

export const EditTag = {
  bindings: {
    me: '<',
    tag: '<',
    groups: '<',
    schoolClasses: '<'
  },
  template,
  controller: EditTagComponent
};
